
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'guided-selling-category-view',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  catalogIsActive: boolean = false;
  categoryId: number | null;
  isLoading: boolean = false;

  @Prop() readonly instanceKey: string;
  @Prop() readonly code: string;
  @Prop() readonly theme: object;
  @Prop() readonly ui: object;
  @Prop() readonly dataSource: string;
  @Prop() readonly language: string;
  @Prop({default: false}) readonly redirectsOnResult: boolean;

  private initializeGuidedSelling(): void {
    window.tweakwiseGuidedSelling({
      output: '#tweakwise-guided-selling',
      instancekey: this.instanceKey,
      code: this.code,
      lang: this.language,
      theme: this.theme,
      ui: this.ui,
      results: {
        handle(event) {
          const results = event.data;

          window.dispatchEvent(new CustomEvent('enableSolarCatalog', {detail: results['navigationurl']}));
        }
      }
    });
  }

  private async enableSolarCatalog(event): Promise<void> {
    this.isLoading = true;
    const body = event.detail;

    if (this.redirectsOnResult) {
      const redirectResponse = await this.$solarClient.post(
          `/api/tweakwise/guided-selling/redirect`,
          body
      );

      if(redirectResponse.data.url) {
        window.location.href = redirectResponse.data.url;
        return;
      }
    }

    const parameterResponse = await this.$solarClient.post(
        `/api/tweakwise/guided-selling/parameters`,
        body
    );
    const parameters = parameterResponse.data;

    this.categoryId = parameters.category;
    const apiUrl = `/api/catalog/category/${this.categoryId}/product/list`;

    this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, this.categoryId);
    this.$solarClient.get(
        apiUrl, {
          params: parameters.filters,
        }).then(({data}) => {
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, data);
    }).finally(() => {
      this.isLoading = false;
      this.catalogIsActive = true;

      let content = document.getElementById('solar-guided-selling-content');
      if (content) {
        content.style.display = 'block';
      }

      document.getElementById('tweakwise-guided-selling-content').style.display = 'none';
    });
  }

  private mounted(): void {
    window.addEventListener('enableSolarCatalog', this.enableSolarCatalog);
    window.addEventListener("load", this.initializeGuidedSelling);
  }
}
